import { Button } from 'blaze-ui/Button'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { TikTokBrand, YouTubeBrand } from 'blaze-ui/icons/20'
import { Heading } from 'blaze-ui/Heading/Heading'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import Styles from './ConnectAccountEmptyState.module.scss'

type SupportedProvider = ExternalIntegrationEnum.TikTok | ExternalIntegrationEnum.YouTube

interface Props {
  provider: SupportedProvider
}

const COPY: Record<SupportedProvider, string> = {
  [ExternalIntegrationEnum.TikTok]: 'Connect TikTok to adjust and control your privacy settings.',
  [ExternalIntegrationEnum.YouTube]: 'Connect YouTube to adjust and control your privacy settings.',
}

const ICON: Record<SupportedProvider, typeof TikTokBrand> = {
  [ExternalIntegrationEnum.TikTok]: TikTokBrand,
  [ExternalIntegrationEnum.YouTube]: YouTubeBrand,
}

export const ConnectAccountEmptyState = ({ provider }: Props) => {
  const { connect } = useConnectAccountPopup({ isSingleSelect: true })

  return (
    <div className={Styles.card}>
      <div className={Styles.copy}>
        <Heading level={4} color="var(--dark-90)">
          {COPY[provider]}
        </Heading>
      </div>
      <InitiateOauthTrigger
        provider={provider}
        popUp
        onInitiatedOauth={(popup) => {
          if (popup) connect(popup, {})
        }}
      >
        <Button size="md" variant="secondary" frontIcon={ICON[provider]}>
          Connect Account
        </Button>
      </InitiateOauthTrigger>
    </div>
  )
}
